import React, { useEffect, useRef, useState } from "react";
import { FloatButton, InputNumber, Layout, message, Result, Skeleton, theme } from "antd";
import AppLogo from "../../assets/images/PrefectosLogos.png";
import MagnaLogo from "../../assets/images/Magnalogo.png";
import { useParams, useSearchParams } from "react-router-dom";
import {
  hideLoading,
  showLoading,
  useLoadingDispatch,
} from "../../context/loadingContext";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Image,
  Input,
  Popconfirm,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Card,
  Switch,
  Alert,
  Upload,
} from "antd";
import AuthService from "../../Components/auth/AuthService";
import Message from "../../Components/common/Message";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import {
  AuthByRole,
  CustomerOrderStatus,
  PostponeReasons,
  deliveryStatuses,
} from "../../Components/common/Constants";
import SignatureCanvas from "react-signature-canvas";
import { Fab, Checkbox as MUICheckbox, createTheme, useMediaQuery, useTheme } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Button as UploadButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import config from "../../Components/config";
import qs from "query-string";
import {
  ArrowLeftOutlined,
  CheckOutlined,
  CloseOutlined,
  RollbackOutlined,
  SyncOutlined,
  DownloadOutlined,
  CameraOutlined,
  PlusOutlined,
  CameraFilled,
} from "@ant-design/icons";
import PostponeModal from "../../Components/Modals/PostponeModal";
import PaymentDiscountModal from "../../Components/Modals/PaymentDiscountModal";
import QRCode from "react-qr-code";
import Loading from "../../Components/loading/Loading";
import CustomerModal from "../../Components/Modals/CustomerModal";

const MyTheme = createTheme({
  breakpoints: {
    values: {
      xs: 450,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const useStyles = makeStyles((theme) => ({
  disableInputs: {
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },
    "& .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector ":
    {
      background: "white",
      color: "black",
    },
  },
  labels: {
    "& .ant-form-item-label": {
      fontWeight: "400",
      padding: "0 0 2px",
      // background: "#8582820a",
      color: "#979191",
    },
  },
  payment: {
    "& .ant-form-item-label": {
      fontWeight: "500",
      padding: "0 0 2px",
      // background: "#8582820a",
      color: "#979191",
    },
    "& .ant-input-outlined[disabled]": {
      background: "none",
      color: "black",
      fontWeight: "500",
    },
  },
  postponeReason: {
    "& .ant-input-outlined[disabled]": {
      background: "white",
      fontWeight: 500,
      color: "black",
    },
    "& .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) .ant-select-selector ":
    {
      background: "white",
      color: "black",
    },
    background: "#ed00007a",
    padding: "10px",
  },
  paymentMethods: {
    "& .ant-form-item-label": {
      fontWeight: "500",
      padding: "0 0 2px",
      // background: "#8582820a",
      color: "#979191",
    },
  },
  dataSheet: {
    "& .ant-checkbox .ant-checkbox-inner": {
      width: "30px",
      height: "32px",
    },
    "& .ant-checkbox+span": {
      fontSize: "14px",
      paddingTop: "4px",
    },
    "& .ant-checkbox-checked .ant-checkbox-inner:after": {
      width: "8px",
      height: "16px",
    },
    [MyTheme.breakpoints.down("xs")]: {
      "& .ant-table-thead>tr>th": {
        padding: "1px 10px !important",
        fontSize: "14px",
        fontWeight: "bold",
      },
      "& .ant-table-tbody>tr>td": {
        padding: "1px 10px !important",
        fontSize: "12px",
      },
      "& .ant-checkbox .ant-checkbox-inner": {
        width: "30px",
        height: "32px",
      },
      "& .ant-checkbox+span": {
        fontSize: "14px",
        paddingTop: "4px",
      },
      "& .ant-checkbox-checked .ant-checkbox-inner:after": {
        width: "8px",
        height: "16px",
      },
    },
  },
  fixedTotal: {
    position: "fixed",
    bottom: "24px",
    right: "24px",
    background: "#fff",
    padding: "12px 24px",
    borderRadius: "12px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    zIndex: 1000,
    textAlign: "center",
    border: "1px solid #f0f0f0",
    transition: "all 0.3s ease",
    [MyTheme.breakpoints.down("sm")]: {
      bottom: "0",
      right: "0",
      left: "0",
      borderRadius: "0",
      padding: "12px 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      boxShadow: "0 -4px 12px rgba(0,0,0,0.08)",
      "& > div:first-child": {
        marginBottom: "0 !important",
        textAlign: "left",
      },
      "& > div:last-child": {
        marginTop: "0 !important",
        textAlign: "right",
      },
    },
  },
  mainContent: {
    padding: "24px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
    [MyTheme.breakpoints.down("sm")]: {
      padding: "16px 12px",
    },
  },
  saveButton: {
    background: "#1890ff",
    borderRadius: "6px",
    fontWeight: 600,
    padding: "0 32px",
    height: "48px",
    fontSize: "16px",
    width: "auto",
    [MyTheme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  mobileNestedTable: {
    "& .ant-table-tbody > tr.ant-table-row:hover > td": {
      background: "transparent !important",
    },
    "& .ant-table-tbody > tr > td": {
      borderBottom: "none !important",
    },
    "& .ant-table": {
      background: "transparent",
    },
  },
}));

const Auth = new AuthService();
const { Header, Content, Footer } = Layout;

const CustomerOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const fileUrl =
    "https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1565&deploy=1&invoiceid=4592882&formid=221&compid=5615243&ns-at=AAEJ7tMQyJ9EQ_rH6lf8EfJ7AmF0qqBANMlsTQMI4Ia7fT7dlyg";

  const [searchParams] = useSearchParams();
  const privateKey = searchParams?.get("security_code");
  console.log("privateKey", id);

  const [routeOrders, setRouteOrders] = React.useState([]);

  const [form] = Form.useForm();
  const classes = useStyles();
  const { TextArea } = Input;
  const { Option } = Select;
  const signatureCanvasRef = useRef(null);

  const [deliveryQuantities, setDeliveryQuantities] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState("");
  const [loadMessage, setLoadMessage] = React.useState("");
  const [myMessage, setMyMessage] = React.useState("");
  const [mySignMessage, setMySignMessage] = React.useState("");
  const [myNameMessage, setMyNameMessage] = React.useState("");
  const [type, setType] = React.useState("info");
  const [signature, setSignature] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [disabledInputs, setDisabledInputs] = useState({});
  const [tableCheckbox, setTableCheckbox] = useState({});
  const [totalPaymentToBeReceived, setTotalPaymentToBeReceived] = useState(0);
  const [outStandingValue, setOutStandingValue] = useState(0);
  const [secret, setSecret] = useState("");
  const [hidePrice, setHidePrice] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  var layoutDispatch = useLoadingDispatch();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const downloadFile = async () => {
    let document_id = routeOrders[0]?.inv_internal_id
      ? routeOrders[0]?.inv_internal_id
      : routeOrders[0]?.internalId;
    let query_string = `${routeOrders[0]?.inv_internal_id ? "invoiceid" : "orderid"}=${document_id}&secret=${secret}`;

    let formid = Number(hidePrice) > 0 ? 227 : 221; // &formid=${formid}
    const url = `https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1565&deploy=1&compid=5615243&ns-at=AAEJ7tMQyJ9EQ_rH6lf8EfJ7AmF0qqBANMlsTQMI4Ia7fT7dlyg&${query_string}`;
    // window.open(url, "_blank");
    const newWindow = window.open(url, "_blank");
    if (!newWindow) {
      window.location.href = url; // Fallback to the same tab if _blank fails
    }
    /*
    setIsLoading(true)
    try {
      const res = await Auth.fetch(`/p/customer-order-secret?document_id=${document_id}`);
      if (res?.ack) {
        // const fileUrl = `https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1565&deploy=1&invoiceid=${routeOrders[0]?.inv_internal_id}&formid=221&compid=5615243&ns-at=AAEJ7tMQyJ9EQ_rH6lf8EfJ7AmF0qqBANMlsTQMI4Ia7fT7dlyg`
        // const url = `https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1982&deploy=1&compid=5615243&ns-at=AAEJ7tMQO9Vvu6nFhSaXf5nVHSGyGGGufO9Fd15EXDK6kcnsvx8&formid=221&invoiceid=${routeOrders[0]?.inv_internal_id}&secret=${res?.secret}`

        let query_string = `${routeOrders[0]?.inv_internal_id ? 'invoiceid' : 'orderid'}=${document_id}&secret=${res?.secret}`;
        const url = `https://5615243.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1565&deploy=1&compid=5615243&ns-at=AAEJ7tMQyJ9EQ_rH6lf8EfJ7AmF0qqBANMlsTQMI4Ia7fT7dlyg&${query_string}`;
        // window.open(url, "_blank");
        const newWindow = window.open(url, "_blank");
        if (!newWindow) {
          window.location.href = url; // Fallback to the same tab if _blank fails
        }
      } else {
        message.error(res?.message)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingInvoice(false)
    }

    */
    // navigate('/customer-invoice/'+id);
  };

  const getOutStandingBalance = async (customerID) => {
    setIsLoading(true);

    try {
      const res = await Auth.fetch(`/p/get-customer-balance?id=${customerID}`);
      if (res?.ack) {
        form.setFieldsValue({
          outstandingBalance: res?.balance,
        });
        setOutStandingValue(res?.balance);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      showLoading(layoutDispatch);
      setLoading(true);
      try {
        const res = await Auth.fetch(`/p/customer-order?security_code=${id}`);

        if (res?.ack && res?.route_pallets.length > 0) {
          const route_orders = [];
          let total_weight = 0;

          res.route_pallets.forEach((rp) => {
            if (Number(rp.internal_id) > 0) {
              let order = route_orders.find(
                (ro) => ro.internalId == rp.internal_id,
              );

              const orderItem = {
                itemPalletId: rp.item_pallet_id,
                itemRank: rp.item_rank,
                itemCode: rp.item_id,
                itemName: rp.item_name,
                quantity: rp.quantity,
                unitPrice:
                  Number(rp.gross_amount_incl_tax) / Number(rp.quantity),
                customerDeliveredQuantity: rp.customer_delivered_quantity,
                customerDeliveryStatus: rp.customer_delivery_status,
              };

              if (order) {
                order.orderWeight += Number(rp.item_total_weight);
                order.orderValue += Number(rp.gross_amount_incl_tax);
                order.items.push(orderItem);
              } else {
                route_orders.push({
                  rank: rp.rank,
                  internalId: rp.internal_id,
                  orderPalletId: rp.order_pallet_id,
                  delivered: rp.delivered,
                  deliveryDiscount: Number(rp.delivery_discount),
                  customerNotes: rp.customer_notes,
                  customerSignature: rp.customer_signature,
                  customerReceivedBy: rp.customer_received_by,
                  customerFiles: rp.customer_files,
                  customerName: rp.customer_project_id,
                  customerCode: rp.customer_name,
                  invoiceNo: rp.invoice_no,
                  inv_internal_id: rp.inv_internal_id,
                  saleOrderNo: rp.sale_order_no,
                  terms: rp.terms,
                  postCode: rp.ship_zip,
                  address: rp.ship_address1,
                  orderWeight: Number(rp.item_total_weight),
                  orderValue: Number(rp.gross_amount_incl_tax),
                  route_status_id: rp.route_status_id,
                  delivery_discount_req_status: rp.delivery_discount_req_status,
                  terms: rp.terms,
                  customer_internal_id: rp.customer_internal_id,
                  items: [orderItem],
                });
              }

              total_weight += Number(rp.item_total_weight);
            }
          });

          route_orders.sort((a, b) => a.rank - b.rank);
          route_orders.map((order) => {
            order.items.sort(function (a, b) {
              return a.itemRank - b.itemRank;
            });
          });
          setRouteOrders(route_orders);
          getOutStandingBalance(route_orders[0]?.customer_internal_id);

          setHidePrice(res?.route_pallets[0]?.hide_invoice_price);
          setSecret(res.secret);
        } else {
          setLoadMessage(res?.message);
          setType("error");
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoading(layoutDispatch);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const clearSignature = () => {
    signatureCanvasRef.current.clear();
    setSignature("");
  };

  const saveSignature = () => {
    const signatureImage = signatureCanvasRef.current.toDataURL();
    setSignature(signatureImage);
  };

  const calculateTotalPaymentToBeReceived = () => {
    let total = 0;
    if (routeOrders.length > 0) {
      routeOrders[0]?.items?.forEach((item) => {
        const deliveredQuantity =
          deliveryQuantities[item.itemPalletId]?.customer_delivered_quantity ||
          0;
        total += deliveredQuantity * item.unitPrice;
      });

      const shouldAddDeliveryCharge =
        routeOrders[0]?.delivery_discount_req_status !== 2;
      if (shouldAddDeliveryCharge) {
        const deliveryChargeItem = routeOrders[0]?.items.find(
          (item) => item.itemCode === "Delivery Charge",
        );
        if (deliveryChargeItem) {
          total += deliveryChargeItem.unitPrice;
        }
      }
    }
    setTotalPaymentToBeReceived(total.toFixed(2));
  };

  useEffect(() => {
    calculateTotalPaymentToBeReceived();
  }, [deliveryQuantities]);

  const handleCheckboxChange = (isChecked, itemPalletId) => {
    setDisabledInputs((prevState) => ({
      ...prevState,
      [itemPalletId]: isChecked,
    }));

    setTableCheckbox((prevState) => ({
      ...prevState,
      [itemPalletId]: isChecked,
    }));
  };

  const handleDeliveryQuantityChange = (value, record, commentId) => {
    const isFullQuantity = value === record.quantity;
    if (value === "full") {
      value = record.quantity;
      commentId = 1;
    }
    if (value === "notFull") {
      value = 0;
      commentId = null;
    }
    const updatedDeliveryQuantities = {
      ...deliveryQuantities,
      [record.itemPalletId]: {
        ...deliveryQuantities[record.itemPalletId],
        customer_delivered_quantity: value,
        customer_delivery_status: commentId,
      },
    };
    if (isFullQuantity) {
      setDisabledInputs((prevState) => ({
        ...prevState,
        [record.itemPalletId]: true,
      }));
      setTableCheckbox((prevState) => ({
        ...prevState,
        [record.itemPalletId]: true,
      }));
    }
    setDeliveryQuantities(updatedDeliveryQuantities);
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete),
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const isMobile = useMediaQuery(MyTheme.breakpoints.down("sm"));

  const desktopColumns = [
    {
      title: "Item Name",
      align: "left",
      dataIndex: "itemName",
      render: (text) => (
        <span style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}>
          {text}
        </span>
      ),
    },
    {
      title: "Qty",
      dataIndex: "quantity",
      key: "quantity",
      width: 80,
      align: "center",
      render: (text) => (
        <span style={{ fontSize: "14px", color: "#333" }}>{text}</span>
      ),
    },
    {
      title: "Received Qty",
      width: 150,
      align: "center",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <Input
            type="number"
            size="large"
            style={{ width: "70px", fontSize: "14px", textAlign: "center" }}
            value={
              deliveryQuantities[record.itemPalletId]
                ?.customer_delivered_quantity || 0
            }
            disabled={disabledInputs[record.itemPalletId]}
            onChange={(e) => {
              const newValue = Math.max(0, e.target.value);
              handleDeliveryQuantityChange(
                newValue,
                record,
                deliveryQuantities[record.itemPalletId]
                  ?.customer_delivery_status,
              );
            }}
          />
          <Checkbox
            checked={tableCheckbox[record.itemPalletId]}
            onChange={(e) => {
              const isChecked = e.target.checked;
              handleCheckboxChange(isChecked, record.itemPalletId);
              handleDeliveryQuantityChange(
                isChecked ? "full" : "notFull",
                record,
                deliveryQuantities[record.itemPalletId]
                  ?.customer_delivery_status,
              );
            }}
          />
        </div>
      ),
    },
    {
      title: "Status",
      width: 150,
      align: "center",
      render: (record) => {
        const deliveryStatus =
          deliveryQuantities[record.itemPalletId]?.customer_delivery_status;
        return (
          <Select
            style={{ width: "100%" }}
            size="medium"
            value={deliveryStatus}
            placeholder="Select Status"
            onChange={(value) =>
              handleDeliveryQuantityChange(
                deliveryQuantities[record.itemPalletId]
                  ?.customer_delivered_quantity,
                record,
                value,
              )
            }
          >
            {CustomerOrderStatus.map((item) => (
              <Option key={item.id} value={item.id}>
                {item.title}
              </Option>
            ))}
          </Select>
        );
      },
    },
  ];

  const mobileColumns = [
    {
      title: "Items",
      key: "stackedDetails",
      render: (record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "8px 0",
          }}
        >
          <div style={{ fontSize: "16px", fontWeight: 700 }}>
            {record.itemName}
          </div>

          <Table
            className={classes.mobileNestedTable}
            dataSource={[record]}
            pagination={false}
            showHeader={false}
            size="small"
            columns={[
              {
                title: "Qty",
                dataIndex: "quantity",
                key: "qty",
                width: 60,
                align: "center",
              },
              {
                title: "Rec Qty",
                key: "recQty",
                width: 130,
                align: "center",
                render: (_, rec) => (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      justifyContent: "center",
                    }}
                  >
                    <InputNumber
                      controls={false}
                      style={{ width: "100%", textAlign: "center" }}
                      value={deliveryQuantities[rec.itemPalletId]?.customer_delivered_quantity || 0}
                      disabled={disabledInputs[rec.itemPalletId]}
                      onChange={(value) =>
                        handleDeliveryQuantityChange(
                          Math.max(0, value),
                          rec,
                          deliveryQuantities[rec.itemPalletId]?.customer_delivery_status
                        )
                      }
                    />
                    <Checkbox
                      checked={tableCheckbox[rec.itemPalletId]}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        handleCheckboxChange(isChecked, rec.itemPalletId);
                        handleDeliveryQuantityChange(
                          isChecked ? "full" : "notFull",
                          rec,
                          deliveryQuantities[rec.itemPalletId]
                            ?.customer_delivery_status,
                        );
                      }}
                    />
                  </div>
                ),
              },
              {
                title: "Status",
                key: "status",
                render: (_, rec) => (
                  <Select
                    style={{ width: "100%" }}
                    value={
                      deliveryQuantities[rec.itemPalletId]
                        ?.customer_delivery_status
                    }
                    placeholder="Status"
                    onChange={(val) =>
                      handleDeliveryQuantityChange(
                        deliveryQuantities[rec.itemPalletId]
                          ?.customer_delivered_quantity,
                        rec,
                        val,
                      )
                    }
                  >
                    {CustomerOrderStatus.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.title}
                      </Option>
                    ))}
                  </Select>
                ),
              },
            ]}
          />
        </div>
      ),
    },
  ];

  const itemColumns = isMobile ? mobileColumns : desktopColumns;

  useEffect(() => {
    if (routeOrders.length > 0) {
      form.setFieldsValue({
        invoiceNo: routeOrders[0]?.invoiceNo,
        shopCode: routeOrders[0]?.customerCode,
        customerName: `${routeOrders[0]?.customerName} (${routeOrders[0]?.customerCode})`,
        total: routeOrders[0]?.orderValue?.toFixed(2),
      });
      setNotes(routeOrders[0]?.customerNotes);
      setSignature(routeOrders[0]?.customerSignature);
      setReceiverName(routeOrders[0]?.customerReceivedBy);
      setCurrentItemFiles(JSON.parse(routeOrders[0]?.customerFiles) || []);

      const initialDeliveryQuantities = {};
      const filteredItems = routeOrders[0]?.items?.filter(
        (item) => item.itemCode !== "Delivery Charge",
      );
      filteredItems.forEach((item) => {
        initialDeliveryQuantities[item.itemPalletId] = {
          item_pallet_id: item.itemPalletId,
          customer_delivered_quantity: item.customerDeliveredQuantity || 0,
          customer_delivery_status: item.customerDeliveryStatus,
        };

        if (item.customerDeliveredQuantity === item.quantity) {
          setDisabledInputs((prevState) => ({
            ...prevState,
            [item.itemPalletId]: true,
          }));
          setTableCheckbox((prevState) => ({
            ...prevState,
            [item.itemPalletId]: true,
          }));
        }
      });
      setDeliveryQuantities(initialDeliveryQuantities);
    }
  }, [routeOrders]);

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleSave = async () => {
    let rand = Math.random() * 50;
    let str = " ";
    for (let i = 0; i < rand; i++) {
      str += " ";
    }

    const itemsWithMissingStatus = Object.values(deliveryQuantities).filter(
      (quantity) => {
        return (
          quantity.customer_delivered_quantity >= 0 &&
          !quantity.customer_delivery_status
        );
      },
    );

    if (itemsWithMissingStatus.length > 0) {
      console.log("itemsWithMissingStatus", itemsWithMissingStatus);
      const missingItemCodes = itemsWithMissingStatus
        .map((item) => {
          const orderItem = routeOrders[0]?.items.find(
            (orderItem) => orderItem.itemPalletId === item.item_pallet_id,
          );
          return orderItem ? orderItem.itemCode : null;
        })
        .filter(Boolean)
        .join(", ");
      setType("error");
      setLoadMessage(
        `Please select the required status for the following items: ${missingItemCodes}${str}`,
      );
      setMyMessage(
        `Please select the required status for the following items: ${missingItemCodes}`,
      );
      // return;
    }
    // if (!signature) {
    //   setMySignMessage(`Please sign the order ${str}`)
    // }
    if (!receiverName) {
      setMyNameMessage(`Please enter your name ${str}`);
    }

    setIsLoading(true);
    const itemsArray = Object.values(deliveryQuantities);
    const dataToSend = {
      customer_notes: notes || "",
      items: itemsArray,
      internal_id: routeOrders[0]?.internalId,
      // customer_signature: signature,
      customer_received_by: receiverName,
      customer_files: currentItemFiles,
    };
    console.log("dataToSend", dataToSend);

    try {
      const res = await Auth.fetch("/p/customer-order", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        const uploadPromises = files.map(async (f) => {
          try {
            const uploadUrl = await getUploadUrl(f);
            await uploadFileToS3(uploadUrl, f.file, f.file.type);
          } catch (error) {
            setLoadMessage("Error uploading file:");
            setType("error");
            console.error("Error uploading file:", error);
          }
        });
        Promise.all(uploadPromises).then(() => {
          setIsLoading(false);
          setType("success");
          setLoadMessage(res.message + str);
          setIsModalOpen(true);
        });
      } else {
        setType("error");
        setLoadMessage(res.message + str);
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getUploadUrl = async (file) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key:
        config.env +
        "/route_orders/" +
        routeOrders[0]?.route_status_id +
        "/" +
        file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      },
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };
  console.log("routeOrders", routeOrders);
  console.log("outStandingValue", outStandingValue);

  const handleSelectAllFull = (isChecked) => {
    const updatedQuantities = { ...deliveryQuantities };

    routeOrders[0]?.items
      ?.filter((item) => item.itemCode !== "Delivery Charge")
      .forEach((item) => {
        const existingData = deliveryQuantities[item.itemPalletId] || {};
        updatedQuantities[item.itemPalletId] = {
          ...existingData,
          customer_delivered_quantity: isChecked ? item.quantity : 0,
          customer_delivery_status: isChecked ? 1 : null,
        };
      });

    const updatedCheckboxes = {};
    const updatedDisabledInputs = {};

    routeOrders[0]?.items
      ?.filter((item) => item.itemCode !== "Delivery Charge")
      .forEach((item) => {
        updatedCheckboxes[item.itemPalletId] = isChecked;
        updatedDisabledInputs[item.itemPalletId] = isChecked;
      });

    // Update state
    setDeliveryQuantities(updatedQuantities);
    setTableCheckbox(updatedCheckboxes);
    setDisabledInputs(updatedDisabledInputs);
  };

  const isAllFull =
    routeOrders[0]?.items?.filter((item) => item.itemCode !== "Delivery Charge")
      ?.length > 0 &&
    routeOrders[0]?.items
      ?.filter((item) => item.itemCode !== "Delivery Charge")
      ?.every((item) => tableCheckbox[item.itemPalletId]);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <Header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          width: "100%",
          display: "flex",
          alignItems: "center",
          background: "#04172f",
          padding: "0 24px",
          height: "48px",
        }}
      >
        <div style={{ display: "flex" }} className="demo-logo">
          <img
            style={{ height: "24px", objectFit: "contain" }}
            src={AppLogo}
            alt="appIcon"
          />
        </div>
      </Header>

      {/* Sub Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#fff",
          padding: "12px 24px",
          borderBottom: "1px solid #e8e8e8",
          flexWrap: "wrap",
          gap: "16px",
        }}
      >
        <div>
          <img style={{ height: "60px" }} src={MagnaLogo} alt="appIcon" />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap" }}>
          <div
            style={{
              textAlign: "left",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                color: "#888",
                fontWeight: 600,
                letterSpacing: "0.5px",
                marginBottom: "4px",
              }}
            >
              INVOICE/ORDER
            </div>
            <div style={{ fontSize: "20px", fontWeight: 600, color: "#333" }}>
              <span style={{ color: "#000", fontWeight: 700 }}>
                #
                {routeOrders[0]?.invoiceNo
                  ? routeOrders[0]?.invoiceNo
                  : routeOrders[0]?.saleOrderNo}
              </span>
            </div>
          </div>
          <Button
            loading={isLoadingInvoice}
            type="primary"
            icon={<DownloadOutlined />}
            size="large"
            style={{
              background: "#1a73e8",
              borderRadius: "6px",
              fontWeight: 600,
              padding: "0 20px",
              height: "40px",
              width: "auto",
            }}
            onClick={() => downloadFile(fileUrl)}
          >
            Download Invoice
          </Button>
        </div>
      </div>

      <Content className={classes.mainContent}>
        <div
          style={{
            minHeight: "80vh",
          }}
        >
          <>
            <>
              {loading ? (
                <>
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                  <Skeleton active />
                </>
              ) : (
                <>
                  {routeOrders?.length > 0 ? (
                    <div className={classes.dataSheet}>
                      <Card
                        bordered={false}
                        style={{
                          marginBottom: "16px",
                          borderRadius: "12px",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
                        }}
                        styles={{ body: { padding: "16px 20px" } }}
                      >
                        <Row gutter={[24, 20]}>
                          <Col xs={24} sm={12} md={8}>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#888",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                marginBottom: "4px",
                              }}
                            >
                              Shop Name
                            </div>
                            <div
                              style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#222",
                                lineHeight: "1.3",
                              }}
                            >
                              {`${routeOrders[0]?.customerName} (${routeOrders[0]?.customerCode})`}
                            </div>
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#888",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                marginBottom: "4px",
                              }}
                            >
                              Outstanding
                            </div>
                            {isLoading ? (
                              <Skeleton.Input active size="small" />
                            ) : (
                              <div
                                style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  color: "#e53935",
                                }}
                              >
                                £{Number(outStandingValue).toFixed(2)}
                              </div>
                            )}
                          </Col>
                          <Col xs={12} sm={6} md={8}>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "#888",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                marginBottom: "4px",
                              }}
                            >
                              Invoice Total
                            </div>
                            <div
                              style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                color: "#222",
                              }}
                            >
                              £{Number(routeOrders[0]?.orderValue).toFixed(2)}
                            </div>
                          </Col>
                        </Row>
                      </Card>

                      <Card
                        bordered={false}
                        style={{
                          marginBottom: "16px",
                          borderRadius: "12px",
                          boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
                        }}
                        styles={{ body: { padding: 0 } }}
                      >
                        <div
                          style={{
                            padding: "16px 20px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          <h3
                            style={{
                              margin: 0,
                              fontWeight: 700,
                              fontSize: "18px",
                              color: "#222",
                            }}
                          >
                            Items List
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "14px",
                                color: "#555",
                                fontWeight: 500,
                              }}
                            >
                              Full Order Received
                            </span>
                            <Switch
                              checked={isAllFull}
                              onChange={(checked) =>
                                handleSelectAllFull(checked)
                              }
                            />
                          </div>
                        </div>
                        <Table
                          columns={itemColumns}
                          dataSource={routeOrders[0]?.items?.filter(
                            (item) => item.itemCode !== "Delivery Charge",
                          )}
                          pagination={false}
                          bordered={false}
                          showHeader={!isMobile}
                          rowClassName={() => "custom-table-row"}
                        />
                      </Card>

                      <Row gutter={[16, 16]}>
                        {/* Notes Column */}
                        <Col xs={24} sm={24} lg={12}>
                          <Card
                            bordered={false}
                            style={{
                              borderRadius: "12px",
                              boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
                              height: "100%",
                            }}
                            styles={{ body: { padding: "16px 20px" } }}
                          >
                            <h4
                              style={{
                                fontWeight: 700,
                                fontSize: "16px",
                                marginBottom: "12px",
                                color: "#222",
                                marginTop: 0,
                              }}
                            >
                              Additional Notes
                            </h4>
                            <TextArea
                              autoSize={{ minRows: 3, maxRows: 5 }}
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                              placeholder="Add any specific instructions or delivery notes here..."
                              style={{ borderRadius: "8px", padding: "10px" }}
                            />
                          </Card>
                        </Col>

                        {/* Receiver Information Column */}
                        <Col xs={24} sm={24} lg={12}>
                          <Card
                            bordered={false}
                            style={{
                              borderRadius: "12px",
                              boxShadow: "0 2px 12px rgba(0,0,0,0.03)",
                              height: "100%",
                            }}
                            styles={{ body: { padding: "16px 20px" } }}
                          >
                            <h4
                              style={{
                                fontWeight: 700,
                                fontSize: "16px",
                                marginBottom: "12px",
                                color: "#222",
                                marginTop: 0,
                              }}
                            >
                              Receiver Information
                            </h4>
                            <div style={{ marginBottom: "12px" }}>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#555",
                                  fontWeight: 600,
                                  marginBottom: "6px",
                                }}
                              >
                                Receiver Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </div>
                              <Input
                                size="large"
                                value={receiverName}
                                onChange={(e) =>
                                  setReceiverName(e.target.value)
                                }
                                placeholder="Enter name of person receiving"
                                style={{ borderRadius: "8px" }}
                              />
                            </div>
                            <Alert
                              message={
                                <span
                                  style={{ fontSize: "12px", color: "#555" }}
                                >
                                  Information required for security and auditing.
                                </span>
                              }
                              type="info"
                              showIcon
                              style={{
                                background: "#f8fbff",
                                border: "1px solid #1a73e820",
                                borderRadius: "8px",
                                padding: "6px 10px",
                              }}
                            />
                          </Card>
                        </Col>
                      </Row>

                      <Divider
                        style={{ borderColor: "#e8e8e8", margin: "12px 0" }}
                      />

                      <Card
                        bordered={true}
                        style={{
                          borderRadius: "12px",
                          borderColor: "#e2e8f0",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.02)",
                        }}
                        styles={{ body: { padding: "16px 20px" } }}
                      >
                        <h4
                          style={{
                            fontWeight: 700,
                            fontSize: "15px",
                            color: "#334155",
                            margin: "0 0 24px 0",
                          }}
                        >
                          Delivery Proof / Photos
                        </h4>

                        <Image.PreviewGroup>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "20px",
                            }}
                          >
                            <Upload
                              showUploadList={false}
                              beforeUpload={(file) => {
                                handleSubmitImage({
                                  target: { files: [file] },
                                  preventDefault: () => { },
                                });
                                return false; // Prevent automatic upload
                              }}
                              accept="image/*, video/*"
                            >
                              <div
                                style={{
                                  width: "min(140px, 30vw)",
                                  height: "min(140px, 30vw)",
                                  background: "#fafafa",
                                  border: "2px dashed #cbd5e1",
                                  borderRadius: "12px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#64748b",
                                  cursor: "pointer",
                                  padding: "8px",
                                }}
                              >
                                <CameraFilled
                                  style={{
                                    fontSize: "min(28px, 6vw)",
                                    marginBottom: "8px",
                                    color: "#94a3b8",
                                  }}
                                />
                                <div
                                  style={{ fontSize: "min(13px, 3vw)", fontWeight: 500, textAlign: "center" }}
                                >
                                  Upload Photo
                                </div>
                              </div>
                            </Upload>

                            {/* Existing Files */}
                            {currentItemFiles?.length > 0 &&
                              currentItemFiles
                                .filter(
                                  (item) =>
                                    !files.some((file) => file.name === item),
                                )
                                .map((item) => {
                                  const imageUrl = `${config.tms_uploads_cdn}/${config.env}/route_orders/${routeOrders[0]?.route_status_id}/${item}`;
                                  return (
                                    <div
                                      key={item}
                                      style={{
                                        position: "relative",
                                        width: "min(140px, 30vw)",
                                        height: "min(140px, 30vw)",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <Image
                                        width="100%"
                                        height="100%"
                                        style={{ objectFit: "cover" }}
                                        src={imageUrl}
                                      />
                                      <Tooltip title="Delete">
                                        <Button
                                          type="text"
                                          icon={<CloseOutlined />}
                                          style={{
                                            position: "absolute",
                                            right: 8,
                                            top: 8,
                                            background: "rgba(255,255,255,0.9)",
                                            border: "none",
                                            color: "#ef4444",
                                            fontSize: "14px",
                                            width: "32px",
                                            height: "32px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "50%",
                                            boxShadow:
                                              "0 2px 4px rgba(0,0,0,0.1)",
                                          }}
                                          onClick={() =>
                                            handleDeleteCurrentFile(item)
                                          }
                                        />
                                      </Tooltip>
                                    </div>
                                  );
                                })}

                            {/* New Files */}
                            {files?.length > 0 &&
                              files.map((fileObj) => {
                                return (
                                  <div
                                    key={fileObj.name}
                                    style={{
                                      position: "relative",
                                      width: "min(140px, 30vw)",
                                      height: "min(140px, 30vw)",
                                      borderRadius: "12px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <Image
                                      width="100%"
                                      height="100%"
                                      style={{ objectFit: "cover" }}
                                      src={URL.createObjectURL(fileObj.file)}
                                    />
                                    <Tooltip title="Delete">
                                      <Button
                                        type="text"
                                        icon={<CloseOutlined />}
                                        style={{
                                          position: "absolute",
                                          right: 8,
                                          top: 8,
                                          background: "rgba(255,255,255,0.9)",
                                          border: "none",
                                          color: "#ef4444",
                                          fontSize: "14px",
                                          width: "32px",
                                          height: "32px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "50%",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.1)",
                                        }}
                                        onClick={() =>
                                          handleDeleteFile(fileObj.name)
                                        }
                                      />
                                    </Tooltip>
                                  </div>
                                );
                              })}
                          </div>
                        </Image.PreviewGroup>
                      </Card>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: "40px",
                          paddingTop: "24px",
                          borderTop: "1px solid #e8e8e8",
                        }}
                      >
                        <Button
                          type="primary"
                          size="large"
                          className={classes.saveButton}
                          loading={isLoading}
                          onClick={handleSave}
                        >
                          Confirm Delivery & Save
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <Result
                      status="500"
                      title="Invalid Request"
                      subTitle="Sorry, no record found."
                    />
                  )}
                </>
              )}
            </>

            <Message type={type} msg={loadMessage} />

            {/* Custom Fixed Total Box mimicking the design */}
            {routeOrders?.length > 0 && !loading && (
              <div className={classes.fixedTotal}>
                <div
                  style={{
                    fontSize: "11px",
                    color: "#666",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Total (GBP)
                </div>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#333",
                    marginTop: "4px",
                  }}
                >
                  £{Number(totalPaymentToBeReceived).toFixed(2)}
                </div>
              </div>
            )}
          </>
        </div>
      </Content>
      <Loading />
      <Footer
        style={{
          textAlign: "center",
        }}
      >
        Prefectos ©{new Date().getFullYear()}
      </Footer>
      <CustomerModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        message={myMessage}
        mySignMessage={mySignMessage}
        myNameMessage={myNameMessage}
        setMessage={setMyMessage}
        setMySignMessage={setMySignMessage}
        setMyNameMessage={setMyNameMessage}
      />
    </Layout>
  );
};
export default CustomerOrder;